import { useContext } from 'react'
import { FeaturesContext } from '../components/main/Features'

function useFeature(featureKey: string): boolean {
  const featureContext = useContext(FeaturesContext)

  return featureContext.includes(featureKey)
}

export default useFeature
